var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 700,
    height: 700,
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m470.93 158.57c1.9258 9.4492-4.1992 18.551-13.648 20.477l-211.05 41.824 211.05 42c6.8242 1.3984 12.25 6.8242 13.648 13.824 1.9258 9.4492-4.1992 18.551-13.648 20.477l-211.05 42 211.05 41.824c6.8242 1.3984 12.25 6.8242 13.648 13.824 1.9258 9.4492-4.1992 18.551-13.648 20.477l-211.05 41.824 216.12 43.051c5.9492 1.0508 10.148 6.3008 10.148 12.25 0 7-5.6016 12.602-12.602 12.602l-231.17-0.003906v-17.5h180.95l-166.95-33.074c-6.8242-1.3984-12.25-6.8242-13.648-13.824-1.9258-9.4492 4.1992-18.727 13.648-20.648l211.05-41.828-211.05-41.84c-6.8281-1.4023-12.25-6.8242-13.652-13.824-1.9258-9.4531 4.1992-18.727 13.652-20.652l211.05-41.824-211.05-41.824c-6.8281-1.4023-12.25-6.8242-13.652-13.824-1.9258-9.4531 4.1992-18.727 13.652-20.652l211.05-41.824-211.05-41.824c-6.8281-1.4023-12.25-6.8242-13.652-13.824-1.9258-9.4531 4.1992-18.727 13.652-20.633l166.95-33.094h-180.95v-17.5h231.18c5.9492 0 11.199 4.1992 12.426 10.148 1.2266 6.8242-3.1484 13.301-9.9766 14.699l-216.12 43.051 211.05 41.828c6.8242 1.418 12.25 6.8438 13.648 13.844z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpring);
export default __webpack_public_path__ + "static/media/Spring.b93252a9c7cfb27968aa1291056234bf.svg";
export { ForwardRef as ReactComponent };